import {autoRegister} from "../../container";
import {GLOBAL} from "../../common/globals";
import type {Nullable} from "../../bootstrap/common/types";

@autoRegister()
export class PageFeatures {

    public constructor(
        private body: HTMLElement = GLOBAL.bodyElement()
    ) {}

    public find<T extends Element>(selector: string): NodeListOf<T> {
        const pageFeaturesElement = this.pageFeaturesElement();
        return pageFeaturesElement.querySelectorAll<T>(selector);
    }

    public findFirst<T extends Element>(selector: string): Nullable<T> {
        const pageFeaturesElement = this.pageFeaturesElement();
        return pageFeaturesElement.querySelector<T>(selector);
    }

    private pageFeaturesElement(): Element {
        const pageFeaturesElement = this.body.querySelector("#pagefeatures");
        if (!pageFeaturesElement) {
            throw new Error("Missing required #pagefeatures element");
        }
        return pageFeaturesElement;
    }
}